import config from '../../configurations/assets.json';

export function assetPrefix() {
    return process.env.NEXT_PUBLIC_APP_ENV === 'development' ? undefined : config.staticPath;
}
